import api from "../../api";
import { computed } from "vue";
import { useStore } from "vuex";
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    Corporates: [],
    CorporatesDoc: [],
    CorporatesDrop: [],
    CorporateEmails: [],
    CorporateEmployees: [],
  },
  getters: {
    getCorporates(state) {
      return state.Corporates;
    },
    getCorporatesDoc(state) {
      return state.CorporatesDoc;
    },
    getCorporatesDrop(state) {
      return state.CorporatesDrop;
    },
    getCorporateEmails(state) {
      return state.CorporateEmails;
    },
    getCorporateEmployees(state) {
      return state.CorporateEmployees;
    },
  },
  mutations: {
    SetCorporates(state, data) {
      state.Corporates = [];
      state.Corporates = data;
    },
    SetCorporatesDoc(state, data) {
      state.CorporatesDoc = [];
      state.CorporatesDoc = data;
    },
    SetCorporatesDrop(state, data) {
      state.CorporatesDrop = [];
      state.CorporatesDrop = data;
    },
    SetCorporateEmails(state, data) {
      state.CorporateEmails = [];
      state.CorporateEmails = data;
    },
    SetCorporateEmployees(state, data) {
      state.CorporateEmployees = data || [];
    },
  },
  actions: {
    fetchAllCorporates({ commit }) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `Corporates/getCorporates`,
            {},
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);

            commit("SetCorporates", res.data);
          })
          .catch((err) => console.log(err));
      });
    },
    getCorporatesDrop({ commit }) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `Corporates/getCorporatesDrop`,
            {},
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);

            commit("SetCorporatesDrop", res.data);
          })
          .catch((err) => console.log(err));
      });
    },
    getCorporatesLogo({ commit }) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `Corporates/getCorporatesLogo`,
            {},
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);

            commit("SetCorporatesDrop", res.data);
          })
          .catch((err) => console.log(err));
      });
    },

    getCorporatesById({ commit }, id) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `Corporates/getCorporatesById`,
            { id: id },
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);

            commit("SetCorporates", res.data);
          })
          .catch((err) => console.log(err));
      });
    },

    addCorporate({}, formData) {
      return new Promise((resolve, rej) => {
        api()
          .post(`Corporates/addCorporate`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",

              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
    editeCorporate({}, formData) {
      return new Promise((resolve, rej) => {
        api()
          .post(`Corporates/editeCorporate`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",

              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },

    deleteCorporate({}, id) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `Corporates/deleteCorporate`,
            { id: id },
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },

    addCorporateEmail({}, formData) {
      return new Promise((resolve) => {
        api()
          .post("Corporates/addCorporateEmail", formData, {
            headers: { Authorization: localStorage.getItem("JwtToken") },
          })
          .then((res) => resolve(res))
          .catch((err) => resolve(err.response));
      });
    },
    editCorporateEmail({}, formData) {
      return new Promise((resolve) => {
        api()
          .post("Corporates/editCorporateEmail", formData, {
            headers: { Authorization: localStorage.getItem("JwtToken") },
          })
          .then((res) => resolve(res))
          .catch((err) => resolve(err.response));
      });
    },
    deleteCorporateEmail({}, formData) {
      return new Promise((resolve) => {
        api()
          .post("Corporates/deleteCorporateEmail", formData, {
            headers: { Authorization: localStorage.getItem("JwtToken") },
          })
          .then((res) => resolve(res))
          .catch((err) => resolve(err.response));
      });
    },
    getCorporateEmails({ commit }, corporateId) {
      return new Promise((resolve, reject) => {
        api()
          .post(
            `Corporates/getCorporateEmails?corporateId=${corporateId}`,
            {},
            {
              headers: { Authorization: localStorage.getItem("JwtToken") },
            }
          )
          .then((res) => {
            if (res.data && res.data.emails) {
              commit("SetCorporateEmails", res.data.emails);
            } else {
              commit("SetCorporateEmails", []);
            }
            resolve(res);
          })
          .catch((err) => reject(err));
      });
    },
    resetCorporateUserPassword({}, emailId) {
      return new Promise((resolve) => {
        const formData = new FormData();
        formData.append("emailId", emailId);
        api()
          .post("Corporates/resetCorporateUserPassword", formData, {
            headers: { Authorization: localStorage.getItem("JwtToken") },
          })
          .then((res) => resolve(res))
          .catch((err) => resolve(err.response));
      });
    },
    fetchCorporateEmployees({ commit }) {
      return new Promise((resolve, reject) => {
        api()
          .get("Corporates/getCorporateEmployees", {
            headers: { Authorization: localStorage.getItem("JwtToken") },
          })
          .then((res) => {
            commit("SetCorporateEmployees", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            commit("SetCorporateEmployees", []);
            reject(err);
          });
      });
    },
    addCorporateEmployee({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        api()
          .post("Corporates/addCorporateEmployee", payload, {
            headers: { Authorization: localStorage.getItem("JwtToken") },
          })
          .then((res) => {
            dispatch("fetchCorporateEmployees");
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteCorporateEmployee({ dispatch }, userId) {
      return new Promise((resolve, reject) => {
        api()
          .delete(`Corporates/deleteCorporateEmployee?userId=${userId}`, {
            headers: { Authorization: localStorage.getItem("JwtToken") },
          })
          .then((res) => {
            dispatch("fetchCorporateEmployees");
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    editCorporateEmployee({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        api()
          .post("Corporates/editCorporateEmployee", payload, {
            headers: { Authorization: localStorage.getItem("JwtToken") },
          })
          .then((res) => {
            dispatch("fetchCorporateEmployees");
            resolve(res);
          })
          .catch((err) => {
            reject(err.response || err);
          });
      });
    },
    resetCorporateEmployeePassword({}, userId) {
      return new Promise((resolve, reject) => {
        api()
          .post(`Corporates/resetCorporateEmployeePassword?userId=${userId}`, {}, {
            headers: { Authorization: localStorage.getItem("JwtToken") },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err.response || err);
          });
      });
    },
  },
};
